// Filename: App.js

import React, {Suspense }from "react";
import { Routes, Route } from "react-router-dom";
import Home from "./pages/home";
import Watch from "./pages/watch";
import Navbar from "./components/Navbar";
import Footer from "./components/MainFooter";
import Rules from "./pages/rules";

import Player from "./pages/Player";
import Login from "./pages/login_final";
import ProtectedRoute from "./ProtectedRoute";
import Forgot from "./pages/Forgot";
import Reset from "./pages/Reset";
import Up from "./pages/Up";
import Info from "./pages/Info";
/*import Signup from "./pages/Signup";*/
import RulesPage from "./pages/RulesPage";
import { useSelector } from "react-redux";

const Signup = React.lazy(() => import('./pages/Signup'));
function App() {
  const authUser = useSelector((state) => state.auth.user);
  return (
    <div>
      <Navbar authUser={authUser} />
      <Routes>
        <Route index element={<Home />} />
        {/* <Route path="/up" element={<Up />} /> */}
        <Route path="/" element={<Home />} />
        <Route path="/Rules" element={<RulesPage />} />
        <Route path="/Home" element={<Home />} />
        <Route path="/Info" element={<Info />} />
        {/* <Route path="/Login" element={<Login />} /> */}
        <Route path="/Rule" element={<Rules />} />
{/*         <Route path="/signup"
              element={
                <Suspense fallback={<div>Loading…</div>}>
                  <Signup />
                </Suspense>
              }
            /> */}
        {/*<Route path="/Signup" element={<Signup />} />
         <Route path="/Video" element={<Video />} /> */}
        {/* <Route path="/Forgot" element={<Forgot />} /> */}
        {/* <Route path="/Register" element={<Register />} /> */}
        <Route path="/Watch" element={<Watch />} />
        <Route path="/video/:videoId" element={<Player />} />
        {/* <Route path="/Reset" element={<Reset />} /> */}
        {/*<Route path="/up" element={<Up />} />*/}
{/*         <Route element={<ProtectedRoute authUser={authUser} />}>
          <Route path="/Upload" element={<Up authUser={authUser} />} />
        </Route>  */}
      </Routes>
      <Footer />
    </div>
  );
}

export default App;
